import Vue from 'vue'

export const ScreenOrientation = {
  landscape: 'landscape',
  portrait: 'portrait'
}

let scrollWidth = 12
let screenPropsTimeOut
let vhTimeOut

const state = Vue.observable({
  screen: {
    height: 680,
    width: 320,
    breakPoint: {
      phoneMedium: false,
      phoneLarge: false,
      phoneXLarge: false,
      tabPort: false,
      tabLand: false,
      smallDesktop: false,
      bigDesktop: false,
      hugeDesktop: false
    },
    orientation: ScreenOrientation.landscape,
    scrollWidth
  }
})

export const ScreenGetters = {
  screen: () => state.screen
}

// LOCAL UTILS
export const getScreenProps = () => {
  clearTimeout(screenPropsTimeOut)
  screenPropsTimeOut = setTimeout(() => {
    const div = document.createElement('div')
    div.style.overflowY = 'scroll'
    div.style.width = '50px'
    div.style.height = '50px'
    document.body.append(div)
    scrollWidth = div.offsetWidth - div.clientWidth
    div.remove()

    if (!window && typeof window.matchMedia !== 'function') {
      state.screen = {
        height: 680,
        width: 320,
        breakPoint: {
          phoneMedium: false,
          phoneLarge: false,
          phoneXLarge: false,
          tabPort: false,
          tabLand: false,
          smallDesktop: false,
          bigDesktop: false,
          hugeDesktop: false
        },
        orientation: ScreenOrientation.landscape,
        scrollWidth
      }

      return
    }

    state.screen = {
      height: window.visualViewport ? +window.visualViewport.height : +window.innerHeight,
      width: +window.innerWidth,
      breakPoint: {
        phoneMedium: window.matchMedia('(min-width: 22.5em)').matches,
        phoneLarge: window.matchMedia('(min-width: 25em)').matches,
        phoneXLarge: window.matchMedia('(min-width: 31.25em)').matches,
        tabPort: window.matchMedia('(min-width: 37.5em)').matches,
        tabLand: window.matchMedia('(min-width: 56.25em)').matches,
        smallDesktop: window.matchMedia('(min-width: 75em)').matches,
        bigDesktop: window.matchMedia('(min-width: 112.5em)').matches,
        hugeDesktop: window.matchMedia('(min-width: 137.5em)').matches
      },
      orientation: window.matchMedia('(orientation: portrait)').matches ? ScreenOrientation.portrait : ScreenOrientation.landscape,
      scrollWidth
    }
  }, 150)
}

(function () {
  // First we get the viewport height and we multiple it by 1% to get a value for a vh unit
  let vh = window.innerHeight * 0.01
  // Then we set the value in the --vh custom property to the root of the document
  document.documentElement.style.setProperty('--vh', `${vh}px`)

  getScreenProps()

  if (window.visualViewport) {
    window.visualViewport.onresize = () => {
      clearTimeout(vhTimeOut)
      vhTimeOut = setTimeout(() => {
        vh = window.visualViewport.height * 0.01
        document.documentElement.style.setProperty('--vh', `${vh}px`)
      }, 150)
      getScreenProps()
    }
  } else {
    window.addEventListener('resize', () => {
      clearTimeout(vhTimeOut)
      vhTimeOut = setTimeout(() => {
        vh = window.innerHeight * 0.01
        document.documentElement.style.setProperty('--vh', `${vh}px`)
      }, 150)
      getScreenProps()
    })
  }
})()
